<main>
  <h1 class="pr-large-t font-heading-1">{{ 'MMB.checkIn.confirmation.title' | finLocalization }}</h1>

  <p class="pr-small-y nordic-blue-900-text">
    {{ 'MMB.checkIn.funnel.confirmation.description' | finLocalization }}
  </p>

  <fcom-button
    data-testid="check-in-feedback-button"
    [text]="'MMB.purchase.success.feedback.button' | finLocalization"
    (clickBtn)="openModal($event)"
  ></fcom-button>

  <fin-qualtrics [survey]="survey" [(open)]="openSurvey"> </fin-qualtrics>

  <div class="mr-medium-y ps-medium border rounded-large nordic-blue-100-border white-bg">
    <div class="flex">
      <fcom-icon
        class="icon-medium nordic-blue-900-text mr-xsmall-r"
        [name]="SvgLibraryIcon.CHECKMARK_BLOCK"
      ></fcom-icon>
      <div>
        <span class="font-body-1">
          {{ 'MMB.checkIn.funnel.steps.confirmation.boardingPassSentMessage' | finLocalization }}</span
        >
        <div class="flex flex--column" data-hj-suppress>
          <span class="font-body-1 bold-type" *ngFor="let email of uniquePassengerEmails$ | async">
            {{ email }}
          </span>
        </div>
        <button data-testid="show-email-modal-button" class="ps-small-y" (click)="showSendEmailModal$.next(true)">
          <span class="flex font-body-1 view-details-info">
            <span class="underline bold-type">{{
              'MMB.checkIn.funnel.confirmation.email.sendAnotherEmail' | finLocalization
            }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>

  <fin-check-in-boarding-pass-status
    [order$]="order$"
    [bound$]="bound$"
    [passengerIds$]="passengerIds$"
    [isCarrierConnect]="isCarrierConnect$ | async"
  ></fin-check-in-boarding-pass-status>

  <div
    class="pr-medium-t font-body-1 bold-type"
    *ngIf="'MMB.checkIn.confirmation.links.passengerRights.url' | finHasLocalizationKey"
  >
    <cms-unstyled-fragment
      [contentUrl$]="'MMB.checkIn.confirmation.links.passengerRights.url' | finLocalization | finToObservable"
    ></cms-unstyled-fragment>
  </div>

  <fin-cartrawler-widget
    *ngIf="showCarTrawlerWidget$ | async"
    [order]="order$ | async"
    [clientId]="carTrawlerClientId"
    extraClasses="mr-medium-t"
  ></fin-cartrawler-widget>

  <fcom-cta-button
    [title]="'MMB.checkIn.confirmation.backToMmb' | finLocalization"
    [position]="ButtonPosition.GRID_FULL"
    [layout]="ButtonLayout.COLUMN"
    (buttonClicked)="redirectToMmb()"
  ></fcom-cta-button>
</main>

<fcom-modal
  data-testid="send-email-modal"
  *ngIf="showSendEmailModal$ | async"
  [fitToContent]="true"
  [forceRemainOpen]="emailSendingInProgress$ | async"
  [open]="true"
  [title]="'MMB.checkIn.funnel.confirmation.email.sendTitle' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [confirmEnabled]="true"
  (close)="showSendEmailModal$.next(false)"
>
  <div class="ps-medium-y pr-large-x">
    <span class="font-body-1 pr-small-y">{{
      'MMB.checkIn.funnel.confirmation.email.sendMessage' | finLocalization
    }}</span>
    <fcom-text-input
      data-testid="email-input"
      class="block ms-small-t"
      [parentForm]="emailForm"
      [displayMargin]="false"
      [translationPrefix]="'paxDetails.fields.email'"
      [controlName]="'email'"
      [id]="'email'"
      [placeHolder]="'paxDetails.fields.email.placeholder'"
      [displayMargin]="false"
    ></fcom-text-input>
  </div>
  <div buttons>
    <div class="align-center send-buttons">
      <fcom-button
        class="ps-small"
        [mode]="ButtonMode.FILL_MOBILE"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [text]="'Close'"
        (clickBtn)="showSendEmailModal$.next(false)"
      >
      </fcom-button>
      <fcom-button
        data-testid="send-email-button"
        class="ps-small"
        [type]="ButtonType.SUBMIT"
        [mode]="ButtonMode.FILL_MOBILE"
        [aria]="{
          disabled: !emailForm.valid || (emailSendingInProgress$ | async) === true,
          loadingLabel: 'actions.loading' | finLocalization,
        }"
        [loading]="(emailSendingInProgress$ | async) === true"
        [text]="'MMB.checkIn.confirmation.email.send' | finLocalization"
        (clickBtn)="sendEmail()"
      ></fcom-button>
    </div>
  </div>
</fcom-modal>
